<template>
    <div class="gallery" v-if="imageUrls.length > 0">
        <template v-if="imageUrls.length > 1">
          <lazy-img 
            :ref="{ 'itemLazyImage': !disableLazyLoad }"
            :image-url="imageOrItemImage"
            :alt="getAltText(imageUrls[0])"
            :title="getTitleText(imageUrls[0])"
            :width="getImageWidth(imageUrls[0])"
            :height="getImageHeight(imageUrls[0])"
            picture-class="mainImg" />

            <lazy-img 
            :ref="{ 'itemLazyImage': !disableLazyLoad }"
            :image-url="imageUrls[1].url"
            :alt="getAltText(imageUrls[1])"
            :title="getTitleText(imageUrls[1])"
            :width="getImageWidth(imageUrls[1])"
            :height="getImageHeight(imageUrls[1])"
            picture-class="secondImg" />
        </template>
        <template v-else>
            <lazy-img 
                :ref="{ 'itemLazyImage': !disableLazyLoad }"
                :image-url="imageOrItemImage"
                :alt="getAltText(imageUrls[0])"
                :title="getTitleText(imageUrls[0])"
                :width="getImageWidth(imageUrls[0])"
                :height="getImageHeight(imageUrls[0])"
                picture-class="mainImg" />
        </template>
    </div>
</template>

<script>
export default {

    name: "category-image-carousel",

    props: {
        imageUrlsData:
        {
            type: Array
        },
        itemUrl:
        {
            type: String
        },
        alt:
        {
            type: String
        },
        title:
        {
            type: String
        },
        showDots:
        {
            type: Boolean,
            default: App.config.item.categoryShowDots
        },
        showNav:
        {
            type: Boolean,
            default: App.config.item.categoryShowNav
        },
        disableLazyLoad: {
            type: Boolean,
            default: false
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        enableCarousel:
        {
            type: Boolean
        },
        template:
        {
            type: String
        },
       
    },

    data()
    {
        return {
            $_enableCarousel: false,
            instance: null
        };
    },
    computed:
    {
        imageUrls()
        {
            return this.imageUrlsData;
        },
        imageOrItemImage()
        {
            return this.imageUrls.length ? this.imageUrls[0].url : this.itemImage;
        }
    },

    mounted()
    {
        // const isMobile = window.matchMedia("(max-width: 768px)").matches;
        // const shouldCarouselBeEnabled = this.enableCarousel && this.imageUrls.length > 1;

        // this.$nextTick(() =>
        // {
        //     if (this.$data.$_enableCarousel)
        //     {
        //         this.initializeCarousel();
        //     }
        // });
    },

    methods:
    {
        initializeCarousel()
        {
            // console.log("Init splide carousel, 4");
            // let type = this.imageUrls.length > 1 ? 'loop' : 'slide';
            // this.instance = new Splide(this.$refs.splideRef, {
            //     type   : type,
            //     drag   : 'true',
            //     snap   : true,
            //     perPage: 1,
            //     lazyLoad: 'nearby'
            // }).mount();

            // let splide = null;
            // const slides = this.$refs.splideRef.querySelectorAll('.splide__slide');
            // console.log("Num Slided", slides.length);
            // // Check the number of slides
            // if (slides.length > 1) {
            //     // Mount Splide if more than one slide
            //     splide = new Splide(this.$refs.splideRef, {
            //         type: 'fade', // or 'slide'
            //         perPage: 1,
            //         lazyLoad: true,
            //         pagination: false, // Disable pagination if not needed
            //         arrows: true, // Enable arrows
            //         speed: 1000,  // Fade transition duration (milliseconds)
            //     }).mount();
                
            //     this.instance = splide;
            // } 

            // // Add event listeners for hover
            // this.$refs.splideRef.addEventListener('mouseenter', this.onHover);
            // this.$refs.splideRef.addEventListener('mouseout', this.onLeave);

        },

        getAltText(image)
        {
            const alt = image && image.alternate ? image.alternate : this.alt;

            return alt;
        },

        getTitleText(image)
        {
            const title = image && image.name ? image.name : this.title;

            return title;
        },

        getImageWidth(image)
        {
            return image && image.width ? image.width : undefined;
        },

        getImageHeight(image)
        {
            return image && image.height ? image.height : undefined;
        },
        onHover() {
            this.instance.go(1); // Go to the second slide (index 1)
        },
        // Change back to the first slide on hover out
        onLeave() {
            this.instance.go(0); // Go to the first slide (index 0)
        }
    }
}
</script>
